import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { StatusDocumento } from '../models/status-documento.model';
import { EventoRepository } from '../repositories/evento.repository';

@Injectable({
  providedIn: 'root'
})
export class EventoService implements EventoRepository {
  private readonly apiEvento = 'evento/referencia/';

  constructor(private readonly http: HttpClient) { }

  listarTiposFeedbacksDocumento(): Observable<StatusDocumento[]> {
    return this.http.get<StatusDocumento[]>(`${environment.FI_FINANC_IMOB_BE}${this.apiEvento}statusDocumento`);
  }
}
